(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    // Find all mini configurator instances on the page
    const roots = document.querySelectorAll('.truck-fitment-mini');
    
    roots.forEach(function(root) {
      const sectionId = root.dataset.sectionId;
      if (!sectionId) return;
      
      initMiniConfigurator(root, sectionId);
    });
  });

  function initMiniConfigurator(root, sectionId) {
    // Helper to get element IDs with section suffix
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    //if display_truck mode and we have a cookie, prefill and show selected-truck summary.
    //Otherwise just populate the make options. We avoid calling populateMake() in both
    //branches because racing the outer fetch with prefill's own populateMake() can wipe
    //the selected make value mid-cascade and leave the selector in a broken state.
    const isDisplayTruck = !!(root && root.dataset.displayTruck === 'true');
    const saved = isDisplayTruck ? getTruckFitmentFromCookie() : null;

    //URL params (?make=Ford&model=F-150&year=2025) win over the cookie so marketing-linked
    //entries land on the selector with their truck prefilled even if a stale cookie exists.
    const urlTruck = getTruckFitmentFromURL();

    //A saved cookie "wins" over a partial URL make param when there's no URL
    //param at all, or when the URL's make agrees with the saved truck's make —
    //i.e. the link the user followed points at the same truck they already
    //configured. This keeps the mini configurator in sync across pages/links
    //instead of forcing the user to re-select a truck they already picked.
    //Only a URL make that DISAGREES with the saved truck is treated as a
    //request to configure a different truck.
    const savedMatchesUrl = !!(saved && urlTruck && saved.make && urlTruck.make &&
      saved.make.trim().toLowerCase() === urlTruck.make.trim().toLowerCase());
    const useSaved = !!(saved && (!urlTruck || savedMatchesUrl));

    //If this page has fitment-aware product cards and we have a saved truck we're
    //going to use, apply the per-card banner/CTA state immediately. Skip when the
    //URL points at a genuinely different truck — the stale cookie would paint
    //banners for a truck the user didn't come here to see; the user will submit
    //the URL-selected truck and banners will update on the next navigation.
    if (useSaved && hasFitmentCards()) {
      applyFitmentToCollection(saved);
    }

    //Subscribe once to the collection facet-update event so banners re-apply after filter/pagination re-renders.
    if (hasFitmentCards() && window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, () => {
        if (lastFitmentState) updateCardFitment(lastFitmentState);
      });
    }

    const config = document.getElementById('configure_fitment_mini_' + sectionId);
    
    if (useSaved) {
      //prefillAndShowSelected owns the full cascade including populateMake()
      prefillAndShowSelected(saved, sectionId);
      // Hide config when cookie exists
      if (config) config.classList.add('hidden');
    } else if (urlTruck) {
      // URL points at a truck that disagrees with (or there's no) saved cookie —
      // let the user configure it. Do NOT hide the config panel here:
      // prefillMiniFromURL() only fills make/model/year (bed length is never
      // accepted from URL), so the user still needs to see the configurator to
      // pick the bed length.
      prefillMiniFromURL(urlTruck, sectionId);
    } else {
      populateMake(sectionId);
      // Show config when NO cookie exists
      if (config) config.classList.remove('hidden');
      if (isDisplayTruck) {
        //no cookie — release the synchronous suppression so the configurator shows
        document.documentElement.classList.remove('truck-fitment-mini-prefill');
      }
    }

    //Change Vehicle (mini)
    const changeBtn = document.getElementById(getId('change-vehicle-mini'));
    if (changeBtn) {
      changeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        //clear cookie + suppression class
        document.cookie = 'truck_fitment=; path=/; max-age=0; SameSite=Lax';
        document.documentElement.classList.remove('truck-fitment-mini-prefill');
        //reset selects
        const makeSelect = document.getElementById(getId('truck-make'));
        if (makeSelect) makeSelect.value = '';
        clearOptionsAfterStep(1, sectionId);
        //toggle panels - SHOW configure (remove hidden), HIDE selected (add hidden)
        const config = document.getElementById('configure_fitment_mini_' + sectionId);
        const selected = document.getElementById(getId('selected-truck-mini'));
        if (config) config.classList.remove('hidden');  // REMOVE hidden class to show config
        if (selected) selected.classList.add('hidden');  // ADD hidden class to hide selected
      });
    }

    //Make selection handler
    const makeSelect = document.getElementById(getId('truck-make'));
    if (makeSelect) {
      makeSelect.addEventListener('change', (event) => {
        clearOptionsAfterStep(1, sectionId);
        populateModel(sectionId);
      });
    }

    //Model selection handler
    const modelSelect = document.getElementById(getId('truck-model'));
    if (modelSelect) {
      modelSelect.addEventListener('change', (event) => {
        clearOptionsAfterStep(2, sectionId);
        populateYear(sectionId);
      });
    }

    //Year selection handler
    const yearSelect = document.getElementById(getId('truck-year'));
    if (yearSelect) {
      yearSelect.addEventListener('change', (event) => {
        clearOptionsAfterStep(3, sectionId);
        populateBed(sectionId);
      });
    }

    //Bed Length selection handler
    const bedSelect = document.getElementById(getId('truck-id'));
    if (bedSelect) {
      bedSelect.addEventListener('change', (event) => {
        toggleSubmitButton(sectionId);
      });
    }

    //Submit handler: save cookie and redirect to collection
    const submitBtn = document.getElementById(getId('truck-submit'));
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (submitBtn.disabled) return;
        saveTruckFitmentCookie(sectionId);
        
        // Add hidden class to configure_fitment_mini
        const config = document.getElementById('configure_fitment_mini_' + sectionId);
        if (config) config.classList.add('hidden');
        
        // Show the selected truck section immediately
        const selected = document.getElementById(getId('selected-truck-mini'));
        
        // Populate the selected truck info
        const makeSelect = document.getElementById(getId('truck-make'));
        const modelSelect = document.getElementById(getId('truck-model'));
        const yearSelect = document.getElementById(getId('truck-year'));
        const bedSelect = document.getElementById(getId('truck-id'));
        
        const makeLabel = makeSelect?.selectedOptions?.[0]?.text || '';
        const modelLabel = modelSelect?.selectedOptions?.[0]?.text || '';
        const yearLabel = yearSelect?.selectedOptions?.[0]?.text || '';
        const bedLabel = bedSelect?.selectedOptions?.[0]?.text || '';
        
        const titleEl = selected?.querySelector('.short-title');
        const bedEl = selected?.querySelector('.bed-length');
        if (titleEl) titleEl.textContent = `${yearLabel} ${makeLabel} ${modelLabel}`;
        if (bedEl) {
          const search = ' with ';
          const idx = bedLabel.toLowerCase().indexOf(search);
          bedEl.textContent = idx === -1 ? bedLabel : bedLabel.slice(idx + search.length);
        }
        
        if (selected) selected.classList.remove('hidden');
        
        if (hasFitmentCards()) {
          //stay on the page and update cards in place
          const truck = getTruckFitmentFromCookie();
          if (truck) applyFitmentToCollection(truck);
        } else {
          window.location.href = '/collections/truck-bed-covers';
        }
      });
    }
  }

  function getTruckFitmentFromCookie() {
    const nameEQ = 'truck_fitment=';
    const cookies = document.cookie ? document.cookie.split(';') : [];
    for (let i = 0; i < cookies.length; i++) {
      const c = cookies[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(decodeURIComponent(c.substring(nameEQ.length)));
        } catch (e) {
          console.error('Failed to parse truck_fitment cookie', e);
          return null;
        }
      }
    }
    return null;
  }

  async function prefillAndShowSelected(truck, sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    const makeSelect  = document.getElementById(getId('truck-make'));
    const modelSelect = document.getElementById(getId('truck-model'));
    const yearSelect  = document.getElementById(getId('truck-year'));
    const bedSelect   = document.getElementById(getId('truck-id'));
    const releaseSuppression = () => document.documentElement.classList.remove('truck-fitment-mini-prefill');
    if (!makeSelect || !modelSelect || !yearSelect || !bedSelect) { releaseSuppression(); return; }

    try {
      await populateMake(sectionId);
      makeSelect.value = truck.make || '';
      if (!makeSelect.value) { releaseSuppression(); return; }

      await populateModel(sectionId);
      modelSelect.value = truck.model || '';
      if (!modelSelect.value) { releaseSuppression(); return; }

      await populateYear(sectionId);
      yearSelect.value = truck.year || '';
      if (!yearSelect.value) { releaseSuppression(); return; }

      await populateBed(sectionId);
      bedSelect.value = truck.id || '';
      if (!bedSelect.value) { releaseSuppression(); return; }

      toggleSubmitButton(sectionId);

      //compose display strings from option text
      const makeLabel  = makeSelect.selectedOptions[0]?.text || truck.make;
      const modelLabel = modelSelect.selectedOptions[0]?.text || truck.model;
      const yearLabel  = yearSelect.selectedOptions[0]?.text || truck.year;
      const bedLabel   = bedSelect.selectedOptions[0]?.text || '';

      const selected = document.getElementById(getId('selected-truck-mini'));
      if (!selected) return;
      const titleEl = selected.querySelector('.short-title');
      const bedEl   = selected.querySelector('.bed-length');
      if (titleEl) titleEl.textContent = `${yearLabel} ${makeLabel} ${modelLabel}`;
      if (bedEl) {
        //strip anything before " with " if present (match main fitment behavior)
        const search = ' with ';
        const idx = bedLabel.toLowerCase().indexOf(search);
        bedEl.textContent = idx === -1 ? bedLabel : bedLabel.slice(idx + search.length);
      }

      // NOTE: fixed the id lookup below to match the actual DOM id
      // (underscore, not the hyphenated getId() helper) so this reliably
      // finds the config panel and hides it.
      const config = document.getElementById('configure_fitment_mini_' + sectionId);
      if (config) config.classList.add('hidden');
      selected.classList.remove('hidden');
      releaseSuppression();
    } catch (err) {
      console.error('Error prefilling mini truck fitment:', err);
      releaseSuppression();
    }
  }

  //Read make/model/year from the URL query string. Bed length is never accepted from URL.
  function getTruckFitmentFromURL() {
    try {
      const params = new URLSearchParams(window.location.search);
      const make  = (params.get('make')  || '').trim();
      const model = (params.get('model') || '').trim();
      const year  = (params.get('year')  || '').trim();
      if (!make) return null;
      return { make, model, year };
    } catch (err) {
      return null;
    }
  }

  //Find an <option> whose value matches rawValue case-insensitively (trimmed).
  function findOptionByValueCI(selectEl, rawValue) {
    if (!selectEl || !rawValue) return null;
    const target = String(rawValue).trim().toLowerCase();
    if (!target) return null;
    const options = selectEl.options;
    for (let i = 0; i < options.length; i++) {
      if (options[i].value && options[i].value.trim().toLowerCase() === target) {
        return options[i];
      }
    }
    return null;
  }

  //Save an incomplete truck (no bed) so the URL-derived selection persists.
  function saveTruckFitmentCookiePartial(partial) {
    const truck_fitment = {
      make:        partial.make        || '',
      model:       partial.model       || '',
      year:        partial.year        || '',
      id:          '',
      make_label:  partial.make_label  || partial.make  || '',
      model_label: partial.model_label || partial.model || ''
    };
    if (!truck_fitment.make || !truck_fitment.model || !truck_fitment.year) return;
    const encoded = encodeURIComponent(JSON.stringify(truck_fitment));
    const maxAgeSeconds = 60 * 60 * 24 * 90;
    document.cookie = `truck_fitment=${encoded}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
  }

  async function prefillMiniFromURL(urlTruck, sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    const makeSelect  = document.getElementById(getId('truck-make'));
    const modelSelect = document.getElementById(getId('truck-model'));
    const yearSelect  = document.getElementById(getId('truck-year'));
    const bedSelect   = document.getElementById(getId('truck-id'));

    const releaseSuppression = () =>
      document.documentElement.classList.remove('truck-fitment-mini-prefill');

    if (!makeSelect || !modelSelect || !yearSelect || !bedSelect) {
      releaseSuppression();
      return;
    }

    try {
      await populateMake(sectionId);
      const makeOpt = findOptionByValueCI(makeSelect, urlTruck.make);
      if (!makeOpt) {
        console.warn('URL make not found in options:', urlTruck.make);
        return;
      }
      makeSelect.value = makeOpt.value;

      await populateModel(sectionId);
      const modelOpt = findOptionByValueCI(modelSelect, urlTruck.model);
      if (!modelOpt) {
        console.warn('URL model not found in options:', urlTruck.model);
        return;
      }
      modelSelect.value = modelOpt.value;

      await populateYear(sectionId);
      const yearOpt = findOptionByValueCI(yearSelect, urlTruck.year);
      if (!yearOpt) {
        console.warn('URL year not found in options:', urlTruck.year);
        return;
      }
      yearSelect.value = yearOpt.value;

      //Load bed options so the user can pick one — we do NOT auto-select a bed or
      //swap to the selected-truck panel; the mini's "selected" view assumes a full truck.
      await populateBed(sectionId);

      saveTruckFitmentCookiePartial({
        make:        makeSelect.value,
        model:       modelSelect.value,
        year:        yearSelect.value,
        make_label:  makeSelect.selectedOptions[0]?.text  || makeSelect.value,
        model_label: modelSelect.selectedOptions[0]?.text || modelSelect.value
      });

      //applyFitmentToCollection bails silently when truck.id is empty, so the per-card
      //fitment banners stay untouched until the user picks a bed and submits.

      toggleSubmitButton(sectionId);
    } catch (err) {
      console.error('Error pre-filling mini truck from URL:', err);
    } finally {
      releaseSuppression();
    }
  }

  function saveTruckFitmentCookie(sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    const makeSelect  = document.getElementById(getId('truck-make'));
    const modelSelect = document.getElementById(getId('truck-model'));
    const yearSelect  = document.getElementById(getId('truck-year'));
    const bedSelect   = document.getElementById(getId('truck-id'));
    const truck_fitment = {
      make:        makeSelect?.value || '',
      model:       modelSelect?.value || '',
      year:        yearSelect?.value || '',
      id:          bedSelect?.value || '',
      make_label:  makeSelect?.selectedOptions?.[0]?.text || makeSelect?.value || '',
      model_label: modelSelect?.selectedOptions?.[0]?.text || modelSelect?.value || ''
    };

    if (!truck_fitment.make || !truck_fitment.model || !truck_fitment.year || !truck_fitment.id) {
      console.warn('Truck fitment incomplete, not saving cookie.');
      return;
    }

    const encoded = encodeURIComponent(JSON.stringify(truck_fitment));
    const maxAgeSeconds = 60 * 60 * 24 * 90;
    document.cookie = `truck_fitment=${encoded}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
  }

  async function populateMake(sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    const makeSelect = document.getElementById(getId('truck-make'));
    if (!makeSelect) {
      console.warn('No #truck-make select found on the page.');
      return;
    }

    try {
      const res = await fetch("https://admin.peragon.com/shopify/makes");

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      //Wait for the JSON
      const makes = await res.json();

      //clear existing options and add a placeholder
      makeSelect.innerHTML = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select The Make';
      makeSelect.appendChild(placeholder);

      //add the values
      Object.entries(makes).forEach(([value, label]) => {
        const opt = document.createElement('option');
        opt.value = value;      // e.g. "Chevrolet"
        opt.textContent = label; // e.g. "Chevrolet"
        makeSelect.appendChild(opt);
      });

      markDuplicateOptions(makeSelect);

      //enable it
      makeSelect.disabled = false;

    } catch (err) {
      console.error('Error loading makes:', err);
    }
  }

  async function populateModel(sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    //object to add options to
    const modelSelect = document.getElementById(getId('truck-model'));
    if (!modelSelect) {
      console.warn('No #truck-model select found on the page.');
      return;
    }
    //current selected values
    const makeSelect = document.getElementById(getId('truck-make'));
    if (!makeSelect) {
      console.warn('No #truck-make select found on the page.');
      return;
    }
    selectedMake = makeSelect.value;

    //clear existing options and add a placeholder
    modelSelect.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select The Model';
    modelSelect.appendChild(placeholder);
    modelSelect.disabled = true;

    if (!selectedMake) {
      return;
    }

    try {
      const res = await fetch("https://admin.peragon.com/shopify/models?make="+selectedMake);

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      //Wait for the JSON
      const models = await res.json();

      //add the values
      Object.entries(models).forEach(([value, label]) => {
        const opt = document.createElement('option');
        opt.value = value;
        opt.textContent = label;
        modelSelect.appendChild(opt);
      });

      markDuplicateOptions(modelSelect);

      //enable it
      modelSelect.disabled = false;

    } catch (err) {
      console.error('Error loading models:', err);
    }
  }

  async function populateYear(sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    // object to add options to
    const yearSelect = document.getElementById(getId('truck-year'));
    if (!yearSelect) {
      console.warn('No #truck-year select found on the page.');
      return;
    }

    // current selected values
    const modelSelect = document.getElementById(getId('truck-model'));
    if (!modelSelect) {
      console.warn('No #truck-model select found on the page.');
      return;
    }
    const selectedModel = modelSelect.value;

    const makeSelect = document.getElementById(getId('truck-make'));
    if (!makeSelect) {
      console.warn('No #truck-make select found on the page.');
      return;
    }
    const selectedMake = makeSelect.value;

    // clear existing options and add a placeholder
    yearSelect.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select The Year';
    yearSelect.appendChild(placeholder);
    yearSelect.disabled = true;

    if (!selectedMake || !selectedModel) {
      return;
    }

    try {
      const res = await fetch(
        `https://admin.peragon.com/shopify/years?make=${encodeURIComponent(selectedMake)}&model=${encodeURIComponent(selectedModel)}`
      );

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      // Wait for the JSON
      const years = await res.json();

      // Convert to entries and sort by key (year) DESC
      const sortedEntries = Object.entries(years).sort(
        ([yearA], [yearB]) => Number(yearB) - Number(yearA)
      );

      // Add the values in sorted order
      sortedEntries.forEach(([value, label]) => {
        const opt = document.createElement('option');
        opt.value = value;
        opt.textContent = label;
        yearSelect.appendChild(opt);
      });

      markDuplicateOptions(yearSelect);

      // enable it
      yearSelect.disabled = false;
    } catch (err) {
      console.error('Error loading years:', err);
    }
  }

  async function populateBed(sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    //object to add options to
    const bedSelect = document.getElementById(getId('truck-id'));
    if (!bedSelect) {
      console.warn('No #truck-id select found on the page.');
      return;
    }
    //current selected values
    const yearSelect = document.getElementById(getId('truck-year'));
    if (!yearSelect) {
      console.warn('No #truck-year select found on the page.');
      return;
    }
    selectedYear = yearSelect.value;
    const modelSelect = document.getElementById(getId('truck-model'));
    if (!modelSelect) {
      console.warn('No #truck-model select found on the page.');
      return;
    }
    selectedModel = modelSelect.value;
    const makeSelect = document.getElementById(getId('truck-make'));
    if (!makeSelect) {
      console.warn('No #truck-make select found on the page.');
      return;
    }
    selectedMake = makeSelect.value;

    //clear existing options and add a placeholder
    bedSelect.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select The Bed Length';
    bedSelect.appendChild(placeholder);
    bedSelect.disabled = true;

    if (!selectedMake || !selectedModel || !selectedYear) {
      return;
    }

    try {
      const res = await fetch("https://admin.peragon.com/shopify/beds?make="+selectedMake+"&model="+selectedModel+"&year="+selectedYear);

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      //Wait for the JSON
      const beds = await res.json();

      //add the values
      Object.entries(beds).forEach(([value, label]) => {
        const opt = document.createElement('option');
        opt.value = value;
        opt.textContent = label;
        bedSelect.appendChild(opt);
      });

      markDuplicateOptions(bedSelect);

      //enable it
      bedSelect.disabled = false;

    } catch (err) {
      console.error('Error loading years:', err);
    }
  }

  function markDuplicateOptions(select) {
    if (!select) return;

    const seen = new Set();

    for (const option of select.options) {
      if (!option.value) continue; // Skip placeholder

      const key = option.value.trim().toLowerCase();

      if (seen.has(key)) {
        option.classList.add('is-duplicated');
      } else {
        seen.add(key);
      }
    }
  }

  function clearOptionsAfterStep(startingStep, sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    const steps = {
      1: {
        id: 'truck-model',
        default_option: 'Select The Model'
      },
      2: {
        id: 'truck-year',
        default_option: 'Select The Year'
      },
      3: {
        id: 'truck-id',
        default_option: 'Select The Bed Length'
      }
    };

    //disable the config button
    const configButton = document.getElementById(getId('truck-submit'));
    if (configButton) {
      configButton.disabled = true;
    }

    // Normalize & guard
    startingStep = Number(startingStep);
    if (startingStep < 1 || startingStep > 3) return;

    for (let step = startingStep; step <= 3; step++) {
      const cfg = steps[step];
      if (!cfg) continue;

      const select = document.getElementById(getId(cfg.id));
      if (!select) continue;

      // Clear existing options
      select.innerHTML = '';

      // Add placeholder option
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = cfg.default_option;
      placeholder.disabled = true;
      placeholder.selected = true;

      select.appendChild(placeholder);

      // Disable until we repopulate via API
      select.disabled = true;
    }
  }

  function toggleSubmitButton(sectionId) {
    const getId = (baseId) => `${baseId}-${sectionId}`;
    
    //object to toggle
    const configButton = document.getElementById(getId('truck-submit'));
    if (!configButton) {
      console.warn('No #truck-submit button found on the page.');
      return;
    }

    //disable it
    configButton.disabled = true;

    //current selected values
    const yearSelect = document.getElementById(getId('truck-year'));
    if (!yearSelect) {
      console.warn('No #truck-year select found on the page.');
      return;
    }
    selectedYear = yearSelect.value;
    const modelSelect = document.getElementById(getId('truck-model'));
    if (!modelSelect) {
      console.warn('No #truck-model select found on the page.');
      return;
    }
    selectedModel = modelSelect.value;
    const makeSelect = document.getElementById(getId('truck-make'));
    if (!makeSelect) {
      console.warn('No #truck-make select found on the page.');
      return;
    }
    selectedMake = makeSelect.value;
    const bedSelect = document.getElementById(getId('truck-id'));
    if (!bedSelect) {
      console.warn('No #truck-id select found on the page.');
      return;
    }
    selectedBed = bedSelect.value;

    //enable if all are chosen
    if (selectedYear && selectedModel && selectedMake && selectedBed) {
      configButton.disabled = false;
    }
  }

  //=====================================================================
  // Collection-page fitment integration
  //=====================================================================

  let lastFitmentState = null;

  function hasFitmentCards() {
    return !!document.querySelector('.product-card[data-reporting-category="1"], .product-card[data-reporting-category="4"]');
  }

  async function applyFitmentToCollection(truck) {
    if (!truck || !truck.id) return;
    try {
      const res = await fetch('https://admin.peragon.com/shopify/availability?truck_id=' + encodeURIComponent(truck.id));
      if (!res.ok) return;
      const json = await res.json();
      if (json.has_error) return;
      lastFitmentState = {
        hasLandmark: !!json.has_landmark,
        hasTectonic: !!json.has_tectonic,
        truck: truck
      };
      updateCardFitment(lastFitmentState);
    } catch (err) {
      console.error('Error fetching availability for collection:', err);
    }
  }

  function updateCardFitment(state) {
    if (!state) return;
    const { hasLandmark, hasTectonic, truck } = state;
    const label = `${truck.make_label || truck.make || ''} ${truck.model_label || truck.model || ''}`.trim();
    const cards = document.querySelectorAll('.product-card[data-reporting-category="1"], .product-card[data-reporting-category="4"]');
    cards.forEach(card => {
      const fits = card.dataset.reportingCategory === '1' ? hasLandmark : hasTectonic;

      //remove any existing banner (only direct children, not descendants)
      const existing = card.querySelector(':scope > .product-card__fitment-banner');
      if (existing) existing.remove();

      const banner = document.createElement('div');
      banner.className = 'product-card__fitment-banner ' + (fits ? 'is-fit' : 'is-unfit');
      banner.innerHTML = (fits ? '<i class="fa-solid fa-square-check"></i> Fits your ' : '<i class="fa-solid fa-square-xmark"></i> Currently unavailable for your ') + label;
      card.prepend(banner);

      const ctaLabel = card.querySelector('[data-fitment-cta-label]');
      if (ctaLabel) ctaLabel.textContent = fits ? 'Shop Now' : 'Learn More';

      card.classList.toggle('product-card--unfit', !fits);
    });
  }

})();
